import { ReactNode } from "react";
import { Trans } from "react-i18next";
import { IconCheckCircle } from "../../icons/IconCheckCircle/IconCheckCircle";
import "./MetIconTitle.scss";

export type Props = {
  title?: string;
  showMetStatus?: boolean;
  met?: boolean;
  children?: ReactNode;
  circleCheckmarkId?: string;
};

const MetIconTitle = ({ title, showMetStatus = false, met = false, children, circleCheckmarkId = "" }: Props) => {
  return (
    <h2 className="met-icon-title__title">
      {showMetStatus === true ? (
        <IconCheckCircle id={circleCheckmarkId} aria-hidden="true" color={met === true ? "green" : "gray"} size="md" />
      ) : (
        <></>
      )}
      <div className="met-icon-title__container">
        <span>
          <Trans>{title}</Trans>
        </span>
      </div>
      {children}
    </h2>
  );
};

export default MetIconTitle;
